(function () {
  'use strict';

  if (window._ddCartPageInit) return;
  window._ddCartPageInit = true;

  var helpers = window.ddCartHelpers;
  if (!helpers) return;

  var LINE_QTY_DEBOUNCE_MS = 120;
  var CHECKOUT_WARN_TTL = 6000;
  var NOTE_SAFETY_TIMEOUT_MS = 15000;
  var CHECKOUT_URL = '/checkout';
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');

  var _linePendingQty = {};
  var _isSavingNote = false;
  var _savingNoteTimeout = null;
  var _footerExpanded = true;
  var _checkoutNavTs = 0;
  var _checkoutWarned = false;
  var _checkoutWarnResetTimer = null;

  /* ── Note-save safety timeout ──
     Mirrors the mini-cart drawer (assets/dd-mini-cart.js L41-55). The
     `_isSavingNote` flag gates concurrent saves; if the underlying fetch
     never resolves (network dropped, app proxy timeout, browser tab
     backgrounded mid-flight), this watchdog releases the flag after
     15s so the next save attempt isn't permanently blocked.
  */
  function startSavingNoteTimeout() {
    clearTimeout(_savingNoteTimeout);
    _savingNoteTimeout = setTimeout(function () {
      if (_isSavingNote) {
        console.warn('[dd-cart-page] _isSavingNote stuck for 15s — force-resetting');
        _isSavingNote = false;
      }
      _savingNoteTimeout = null;
    }, NOTE_SAFETY_TIMEOUT_MS);
  }

  function clearSavingNoteTimeout() {
    clearTimeout(_savingNoteTimeout);
    _savingNoteTimeout = null;
  }

  function clearCheckoutWarnState() {
    _checkoutWarned = false;
    clearTimeout(_checkoutWarnResetTimer);
    _checkoutWarnResetTimer = null;
  }

  function getPageRoot() {
    return document.getElementById('main-cart-footer') || document;
  }

  function getScopedNode(sel) {
    var root = getPageRoot();
    var el = root.querySelector(sel);
    return el || document.querySelector(sel);
  }

  function isCartPageScope(node) {
    if (!node || !node.closest) return false;
    return !!(node.closest('form#cart') || node.closest('#main-cart-items') || node.closest('#main-cart-footer'));
  }

  function getCartPageSections() {
    /* 'cart-drawer' rides every cart-page mutation (not just adds): the drawer
       coexists in the DOM on /cart and its stamps/badges go stale if only the
       page sections re-render (two-surface rule). Same request, zero extra. */
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var itemsRoot = document.getElementById('main-cart-items');
    var footerRoot = document.getElementById('main-cart-footer');
    if (itemsRoot && itemsRoot.dataset.id) sections.push(itemsRoot.dataset.id);
    if (footerRoot && footerRoot.dataset.id) sections.push(footerRoot.dataset.id);
    return sections;
  }

  function getCartPageAddSections() {
    return getCartPageSections();
  }

  /* ── CreditsYard embedded widget guard (cart page only) ──
     CSS hiding can lose to app-injected inline !important styles.
     Remove hosts from DOM so app reflows can't resurface them. */
  var CREDITSYARD_EMBED_SELECTORS = [
    'creditsyard-embedded-widget',
    'store-credit-embedded-widget',
    'store-credit-embedded-wrapper',
    '.creditsyard-embedded-widget',
    '.store-credit-embedded-widget',
    '[class*="creditsyard-embedded-widget"]',
    '[class*="store-credit-embedded-widget"]',
    '[id*="creditsyard-embedded-widget"]',
    '[id*="store-credit-embedded-widget"]',
    '[class*="store-credit-embedded-wrapper"]'
  ].join(', ');
  var _creditsyardPruneRaf = 0;
  var _creditsyardWatchdogTimer = null;

  function killCreditsYardNode(node) {
    if (!node || node.nodeType !== 1) return;
    try {
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
      node.setAttribute('hidden', 'hidden');
      node.setAttribute('aria-hidden', 'true');
    } catch (_e) {}
    if (node.parentNode) node.parentNode.removeChild(node);
  }

  function pruneCreditsYardEmbedded(root) {
    root = root && root.querySelectorAll ? root : document;
    var nodes = root.querySelectorAll(CREDITSYARD_EMBED_SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      killCreditsYardNode(nodes[i]);
    }
  }

  function scheduleCreditsYardPrune() {
    if (_creditsyardPruneRaf) return;
    _creditsyardPruneRaf = requestAnimationFrame(function () {
      _creditsyardPruneRaf = 0;
      pruneCreditsYardEmbedded(document);
    });
  }

  if (document.body && document.body.classList.contains('template-cart')) {
    pruneCreditsYardEmbedded(document);
    var creditsyardObserver = new MutationObserver(function () {
      scheduleCreditsYardPrune();
    });
    creditsyardObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
    _creditsyardWatchdogTimer = setInterval(function () {
      pruneCreditsYardEmbedded(document);
    }, 1200);
    window.addEventListener('pagehide', function () {
      if (_creditsyardWatchdogTimer) {
        clearInterval(_creditsyardWatchdogTimer);
        _creditsyardWatchdogTimer = null;
      }
    }, { once: true });
  }

  function findQtyInput(lineKey) {
    if (!lineKey) return null;
    return document.querySelector('[data-dd-qty-input][data-line-key="' + lineKey + '"]');
  }

  function setLineUpdating(lineKey, busy) {
    if (!lineKey) return;
    var item = document.querySelector('[data-dd-cart-item][data-line-key="' + lineKey + '"]');
    if (!item) return;
    item.classList.toggle('cart-item--line-updating', busy);
    var controls = item.querySelectorAll('[data-dd-qty-minus], [data-dd-qty-plus], [data-dd-remove-item], [data-dd-qty-input]');
    for (var i = 0; i < controls.length; i++) {
      if (busy) controls[i].setAttribute('disabled', 'disabled');
      else controls[i].removeAttribute('disabled');
    }
  }

  function clearAllLineUpdating() {
    var items = document.querySelectorAll('[data-dd-cart-item].cart-item--line-updating');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('cart-item--line-updating');
      var controls = items[i].querySelectorAll('[data-dd-qty-minus], [data-dd-qty-plus], [data-dd-remove-item], [data-dd-qty-input]');
      for (var j = 0; j < controls.length; j++) controls[j].removeAttribute('disabled');
    }
  }

  function announceCartStatus(msg) {
    var el = document.getElementById('cart-live-region-text');
    if (el) el.textContent = msg;
  }

  /* ── Unsaved-field helpers (parity with dd-mini-cart.js L525-560) ──
     `hasUnsavedDiscount` returns true when the discount input has any
     non-blank text (an unconfirmed code the user typed but didn't apply).
     `hasUnsavedNote` returns true when the note input's current value
     differs from the SSR-stamped `data-dd-initial-note` baseline (an
     edited note the user didn't save).
     Both are used in the checkout-submit guard so we can warn the
     shopper before they leave the cart page with work-in-progress.
  */
  function hasUnsavedDiscount() {
    var input = getScopedNode('[data-dd-discount-input]');
    if (!input) return false;
    return (input.value || '').trim() !== '';
  }

  function hasUnsavedNote() {
    var input = getScopedNode('[data-dd-note-input]');
    if (!input) return false;
    var saved = (input.dataset.ddInitialNote || '').trim();
    return (input.value || '').trim() !== saved;
  }

  function shakeEl(el) {
    if (!el) return;
    el.classList.remove('is--shake');
    /* Reflow to restart the CSS animation reliably */
    void el.offsetWidth;
    el.classList.add('is--shake');
    el.addEventListener('animationend', function handler() {
      el.classList.remove('is--shake');
      el.removeEventListener('animationend', handler);
    });
  }

  /* A free gift is only genuinely "unclaimed and actionable" when its
     claim/decline card is rendered AND visible. The checkout gate below
     MUST share this exact signal with the card render in dd-cart-gift.js
     (renderSlot) — otherwise a stale/independent DDCartState.qualifies
     (set from a prior BOGOS event or threshold) can block checkout while
     no card is shown, trapping the shopper with nothing to claim or
     decline. `:not([hidden])` skips animated-out slots; getClientRects()
     catches display:none ancestors and the not-yet-rendered FOUC guard.
     (Workspace visibility-handoff rule.) */
  function hasVisibleGiftCard() {
    var cards = document.querySelectorAll('[data-dd-bogos-slot]:not([hidden]) .dd-bogos-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      /* "Visible" must mean the shopper can actually SEE and act on the card,
         not merely that it occupies layout. getClientRects()/layout is true for
         BOTH opacity:0 and visibility:hidden, so a card stranded mid-enter
         (is-entering -> opacity:0) or inside a closed drawer (visibility:hidden)
         would falsely arm the checkout gate and trap the shopper with nothing to
         claim or decline. checkVisibility (where supported) rejects all three
         (display:none, visibility:hidden, opacity:0); the fallback mirrors it. */
      if (typeof card.checkVisibility === 'function') {
        if (card.checkVisibility({ visibilityProperty: true, opacityProperty: true })) return true;
        continue;
      }
      if (card.getClientRects().length === 0) continue;
      var cs = window.getComputedStyle(card);
      if (!cs) return true;
      if (cs.visibility === 'hidden' || cs.opacity === '0') continue;
      return true;
    }
    return false;
  }

  /* Toggle a single footer accordion's open state WITHOUT affecting
     siblings — required when highlighting both the discount and note
     accordions at once. The legacy `openCartPageAccordion` (still used
     by the discount-badge → focus flow below) closes all siblings
     before opening its target, so calling it twice in `highlightUnsavedFields`
     leaves only the second one open. Mirrors the drawer's
     `setDrawerAccordionOpen` (assets/dd-mini-cart.js L569-582). */
  function syncCartPageAccordionAria(accordion, open) {
    if (!accordion) return;
    var toggles = accordion.querySelectorAll('[data-dd-accordion-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].hasAttribute('aria-expanded')) {
        toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  }

  function setCartPageAccordionOpen(target, open) {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var accordion =
      target === 'discount'
        ? footer.querySelector('[data-dd-discount-accordion]')
        : target === 'note'
          ? footer.querySelector('[data-dd-note-accordion]')
          : null;
    if (!accordion) return;
    accordion.classList.toggle('is--open', !!open);
    syncCartPageAccordionAria(accordion, open);
  }

  function getCartPageHeaderDiscountStrip() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return null;
    return footer.querySelector('[data-dd-discount-accordion] [data-dd-cart-discounts]');
  }

  function syncCartPageDiscountChipOverflow() {
    var strip = getCartPageHeaderDiscountStrip();
    if (!strip) return;
    var chips = strip.querySelectorAll('.dd-cart-discount:not(.dd-cart-note-badge):not(.dd-cart-discounts__more)');
    var extra = chips.length - 1;
    var pill = strip.querySelector('.dd-cart-discounts__more');
    if (extra > 0) {
      var label = '+' + extra;
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'dd-cart-discount dd-cart-discounts__more';
        pill.setAttribute('aria-hidden', 'true');
        strip.appendChild(pill);
      }
      if (pill.textContent !== label) pill.textContent = label;
      if (pill.previousElementSibling !== chips[0]) {
        chips[0].insertAdjacentElement('afterend', pill);
      }
    } else if (pill) {
      pill.remove();
    }
  }

  function initCartPageDiscountChipOverflow() {
    var strip = getCartPageHeaderDiscountStrip();
    if (!strip) return;
    syncCartPageDiscountChipOverflow();
    if (strip._ddOverflowObserved) return;
    strip._ddOverflowObserved = true;
    var mo = new MutationObserver(syncCartPageDiscountChipOverflow);
    mo.observe(strip, { childList: true });
  }

  function highlightUnsavedFields(unsavedDiscount, unsavedNote) {
    if (unsavedDiscount) {
      var dLabel = getScopedNode('[data-dd-discount-label]');
      shakeEl(dLabel);
      setCartPageAccordionOpen('discount', true);
    }
    if (unsavedNote) {
      var nLabel = getScopedNode('[data-dd-note-label]');
      shakeEl(nLabel);
      setCartPageAccordionOpen('note', true);
    }
  }

  function isCustomerLoggedIn() {
    var attr = document.documentElement.getAttribute('data-glass-customer-id');
    return !!(attr && attr !== '' && attr !== '0');
  }

  function isAuthoritativeCartData(cartData) {
    return !!(cartData && typeof cartData.item_count === 'number' && Array.isArray(cartData.items));
  }

  function extractCartFromEventPayload(payload) {
    if (helpers && typeof helpers.extractCartFromEventDetail === 'function') {
      return helpers.extractCartFromEventDetail(payload);
    }
    if (!payload || typeof payload !== 'object') return null;
    if (isAuthoritativeCartData(payload.cartData)) return payload.cartData;
    if (isAuthoritativeCartData(payload.cart)) return payload.cart;
    if (isAuthoritativeCartData(payload)) return payload;
    return null;
  }

  function updateEmptyState(cartData) {
    var cartEl = document.querySelector('cart-items.dd-cart-parity');
    if (!cartEl) return;
    var isEmpty = !cartData || cartData.item_count === 0;
    cartEl.classList.toggle('is-empty', isEmpty);
    var footerWrap = document.getElementById('main-cart-footer');
    if (footerWrap) footerWrap.classList.toggle('is-empty', isEmpty);
  }

  /* ── Threshold bar ── */
  function updateThresholdBar(cartData) {
    var thresholdEl = document.querySelector('.dd-threshold[data-dd-threshold]');
    if (!thresholdEl || !cartData) return;
    var threshold = parseInt(thresholdEl.dataset.ddThreshold, 10) || 0;
    if (!threshold) return;

    var items = cartData.items || [];
    var merchSubtotal = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (Number(it.product_id || 0) === 10266015924541) continue;
      var props = it && it.properties && typeof it.properties === 'object' ? it.properties : null;
      if (props && (props._dd_shipping_protection || props.dd_shipping_protection)) continue;
      var h = (it.handle || '').toLowerCase();
      var v = (it.vendor || '').toLowerCase();
      var t = (it.title || '').toLowerCase();
      var isProt = h === 'dd-shipping-protection' || v.indexOf('insureshield') !== -1 ||
        v.indexOf('insure shield') !== -1 || t.indexOf('shipping protection') !== -1 ||
        t.indexOf('shipping insurance') !== -1;
      if (!isProt) merchSubtotal += Number(it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    }
    var domRaw = thresholdEl.getAttribute('data-dd-merch-subtotal-cents');
    if (domRaw != null && domRaw !== '') {
      var domMerch = parseInt(domRaw, 10);
      if (isFinite(domMerch) && domMerch >= 0 && merchSubtotal === 0 && domMerch > 0) {
        merchSubtotal = domMerch;
      }
    }

    var pct = Math.min(100, Math.round(merchSubtotal * 100 / threshold));
    var done = merchSubtotal >= threshold;
    thresholdEl.classList.toggle('is--done', done);
    var barWrap = thresholdEl.querySelector('.dd-threshold__bar-wrap');
    if (barWrap) {
      barWrap.style.setProperty('--dd-threshold-pct', pct + '%');
      barWrap.setAttribute('aria-valuenow', String(pct));
    }
    var textEl = thresholdEl.querySelector('[data-dd-threshold-text]');
    if (textEl) {
      if (done) {
        textEl.innerHTML = '<svg class="dd-threshold__check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span class="dd-threshold__congrats"><strong>Congratulations!</strong> You\'ve got free 2-day shipping!</span>';
      } else if (!isCustomerLoggedIn()) {
        /* Guest copy must persist after mutations — otherwise the
           SSR-stamped string sticks while the bar % updates, creating
           a "you saw it logged-out" inconsistency. Mirrors mini-cart
           behavior at dd-mini-cart.js:1532-1533. */
        textEl.innerHTML = 'Free shipping on qualifying orders';
      } else if (merchSubtotal <= 0) {
        /* Empty-cart for logged-in pros — mirrors dd-mini-cart.js:1535. */
        textEl.innerHTML = 'Free shipping on orders over ' + helpers.formatMoney(threshold);
      } else {
        var remaining = threshold - merchSubtotal;
        textEl.innerHTML = 'Add ' + helpers.formatMoney(remaining) + ' more for free 2-day shipping';
      }
    }
  }

  /* ── Qty debounce + mutation ── */
  function updateItemQuantity(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl) {
    if (!lineKey && (!lineNumber || lineNumber < 1)) return;
    var isExplicitRemove = qty === 0 && !!itemTitle;
    var pendingKey = lineKey || ('line:' + String(lineNumber));
    var pending = _linePendingQty[pendingKey];

    if (isExplicitRemove) {
      if (pending && pending.timer) clearTimeout(pending.timer);
      delete _linePendingQty[pendingKey];
      executeQuantityUpdate(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl);
      return;
    }

    if (!pending) {
      pending = _linePendingQty[pendingKey] = {
        lineKey: lineKey, lineNumber: lineNumber || 0, qty: qty,
        itemTitle: itemTitle || '', previousQty: previousQty,
        sourceEl: sourceEl || null, timer: null
      };
    } else {
      pending.qty = qty;
      if (pending.previousQty == null && previousQty != null) pending.previousQty = previousQty;
      pending.sourceEl = sourceEl || pending.sourceEl;
      if (pending.timer) clearTimeout(pending.timer);
    }

    pending.timer = setTimeout(function () {
      var latest = _linePendingQty[pendingKey];
      if (!latest) return;
      delete _linePendingQty[pendingKey];
      executeQuantityUpdate(latest.lineKey, latest.lineNumber, latest.qty,
        latest.itemTitle, latest.previousQty, latest.sourceEl);
    }, LINE_QTY_DEBOUNCE_MS);
  }

  function getCommittedQtyFromCartPage(data, lineKey) {
    var items = data && Array.isArray(data.items) ? data.items : [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === lineKey) return items[i].quantity;
    }
    return null;
  }

  function executeQuantityUpdate(lineKey, lineNumber, qty, itemTitle, previousQty, sourceEl) {
    if (!lineKey && (!lineNumber || lineNumber < 1)) return;
    var isRemoval = qty === 0;
    clearAllLineUpdating();
    if (lineKey) setLineUpdating(lineKey, true);

    var body = { quantity: qty };
    if (lineKey) body.id = lineKey;
    else if (lineNumber > 0) body.line = lineNumber;

    helpers.mutateCartChange(body, {
      action: isRemoval ? 'line-remove' : 'line-qty-change',
      coalesceKey: helpers.makeCoalesceKey('line', lineKey || lineNumber || 'unknown')
    })
      .then(function (data) {
        clearAllLineUpdating();
        if (data) {
          updateEmptyState(data);
          updateThresholdBar(data);
        }
        var postInput = findQtyInput(lineKey);
        if (!isRemoval && postInput) {
          var committed = getCommittedQtyFromCartPage(data, lineKey);
          if (committed != null) {
            postInput.setAttribute('data-dd-prev-qty', String(committed));
            if (committed < qty) {
              postInput.value = String(committed);
              /* Three-string cap parity with dd-mini-cart.js L1196-1208:
                   - committed > 0  → adjusted-down ('Only N available')
                   - committed = 0 with prior stock → fully sold-out
                   - committed = 0 from cold (rare) → no-more-stock
                 The drawer differentiates "sold out for the selected option"
                 from "no more stock" so the shopper knows whether to switch
                 variants vs wait for restock. */
              var capMsg;
              var capType;
              if (committed > 0) {
                capMsg = 'Only ' + committed + ' available \u2014 quantity has been adjusted.';
                capType = 'info';
              } else if (previousQty != null && previousQty > 0) {
                capMsg = 'This item is sold out for the selected option.';
                capType = 'error';
              } else {
                capMsg = 'No more stock is available for this option.';
                capType = 'error';
              }
              announceCartStatus(capMsg);
              if (window.ddToast) window.ddToast(capMsg, { type: capType });
              return;
            }
          } else {
            var serverVal = parseInt(postInput.value, 10);
            if (!isNaN(serverVal) && serverVal >= 0) postInput.setAttribute('data-dd-prev-qty', String(serverVal));
          }
        }
        announceCartStatus(isRemoval ? ((itemTitle || 'Item') + ' removed') : 'Cart updated');
      })
      .catch(function (err) {
        clearAllLineUpdating();
        var input = findQtyInput(lineKey);
        if (input && previousQty != null) {
          input.value = String(previousQty);
          input.setAttribute('data-dd-prev-qty', String(previousQty));
        }
        var parsed = helpers.parseCartStockError
          ? helpers.parseCartStockError(err, { operation: 'change', requestedQty: qty, previousQty: previousQty })
          : null;
        var stockMsg = parsed && helpers.stockErrorMessage
          ? helpers.stockErrorMessage(parsed, { operation: 'change' })
          : null;
        var msg = (stockMsg && stockMsg.message)
          || (isRemoval ? 'Couldn\u2019t remove item \u2014 please try again' : 'Couldn\u2019t update cart \u2014 please try again');
        var toastType = (stockMsg && stockMsg.toastType) || 'error';
        announceCartStatus('Could not update cart');
        if (window.ddToast) window.ddToast(msg, { type: toastType });
      });
  }

  /* ── Click delegation ── */
  document.addEventListener('click', function (e) {
    var clickTarget = e && e.target;
    if (clickTarget && clickTarget.nodeType === 3) clickTarget = clickTarget.parentElement;
    if (!clickTarget || typeof clickTarget.closest !== 'function') return;

    var qtyMinus = clickTarget.closest('[data-dd-qty-minus]');
    if (qtyMinus && isCartPageScope(qtyMinus)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleQtyBtn(qtyMinus, -1);
      return;
    }

    var qtyPlus = clickTarget.closest('[data-dd-qty-plus]');
    if (qtyPlus && isCartPageScope(qtyPlus)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleQtyBtn(qtyPlus, 1);
      return;
    }

    var removeBtn = clickTarget.closest('[data-dd-remove-item]');
    if (removeBtn && isCartPageScope(removeBtn)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleRemove(removeBtn);
      return;
    }

    var cartFoot = clickTarget.closest('#main-cart-footer');
    if (cartFoot) {
      /* Note-badge × remove button — clears the saved order note in
         place, mirroring the drawer's `data-dd-note-badge-remove` flow
         (assets/dd-mini-cart.js:215, 240-241; clearNote at L491-523). */
      var noteBadgeRemove = clickTarget.closest('[data-dd-note-badge-remove]');
      if (noteBadgeRemove) {
        e.preventDefault();
        e.stopImmediatePropagation();
        clearCartPageNote();
        return;
      }

      var footerDiscBadge = clickTarget.closest('[data-dd-discount-badge]');
      if (
        footerDiscBadge &&
        footerDiscBadge.closest('[data-dd-cart-discounts]') &&
        !clickTarget.closest('.dd-cart-discount__remove') &&
        (footerDiscBadge.getAttribute('data-discount-type') || '').trim() === 'discount_code'
      ) {
        e.preventDefault();
        openCartPageAccordion('discount');
        requestAnimationFrame(function () {
          var inp = cartFoot.querySelector('[data-dd-discount-input]');
          if (inp && typeof inp.focus === 'function') {
            inp.focus();
            try {
              if (typeof inp.select === 'function') inp.select();
            } catch (ex) {}
          }
        });
        return;
      }
    }

    /* Clear the unsaved-fields cooldown when the shopper actually
       applies a discount or saves a note — they've handled the warning,
       so the next checkout click should proceed without re-warning.
       Mirrors dd-mini-cart.js:2049-2056. */
    if (clickTarget.closest('[data-dd-discount-apply]') || clickTarget.closest('[data-dd-note-save]')) {
      clearCheckoutWarnState();
    }

    var accordionToggle = clickTarget.closest('[data-dd-accordion-toggle]');
    if (
      accordionToggle &&
      accordionToggle.closest('#main-cart-footer') &&
      !clickTarget.closest('.dd-cart-discount__remove, [data-dd-discount-badge][data-discount-type="discount_code"]')
    ) {
      e.preventDefault();
      handleAccordionToggle(accordionToggle);
      return;
    }

    var footerToggle = clickTarget.closest('[data-dd-footer-toggle]');
    if (footerToggle && footerToggle.closest('#main-cart-footer')) {
      e.preventDefault();
      setFooterExpanded(!_footerExpanded);
      return;
    }

    var noteSave = clickTarget.closest('[data-dd-note-save]');
    if (noteSave && noteSave.closest('#main-cart-footer')) {
      e.preventDefault();
      handleNoteSave();
      return;
    }

    var upsellAdd = clickTarget.closest('[data-dd-upsell-add]');
    if (upsellAdd && isCartPageScope(upsellAdd)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleUpsellAdd(upsellAdd);
      return;
    }

    var crossAdd = clickTarget.closest('[data-dd-cross-sell-add]');
    if (crossAdd && isCartPageScope(crossAdd)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleCrossSellAdd(crossAdd);
      return;
    }
  }, true);

  /* Qty change from direct input editing */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-dd-qty-input]')) return;
    if (!isCartPageScope(e.target)) return;
    var input = e.target;
    var rawVal = parseInt(input.value, 10);
    var prev = parseInt(input.getAttribute('data-dd-prev-qty') || input.value, 10) || 0;
    if (isNaN(rawVal) || rawVal < 0) {
      input.value = String(prev || 1);
      return;
    }
    var qty = rawVal;
    if (qty === prev) return;
    input.value = String(qty);
    if (input.dataset.lineKey) {
      var lineNumber = parseInt(input.dataset.line || '0', 10) || 0;
      updateItemQuantity(input.dataset.lineKey, lineNumber, qty, null, prev, input);
    }
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('[data-dd-qty-input]')) return;
    if (!isCartPageScope(e.target)) return;
    var qty = parseInt(e.target.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    e.target.setAttribute('data-dd-prev-qty', String(qty));
  });

  /* ── Key handlers ── */
  document.addEventListener('keydown', function (e) {
    var keyTarget = e && e.target;
    if (keyTarget && keyTarget.nodeType === 3) keyTarget = keyTarget.parentElement;
    if (!keyTarget || typeof keyTarget.closest !== 'function') return;
    if (keyTarget.closest('[data-dd-footer-toggle]') &&
        keyTarget.closest('#main-cart-footer') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      setFooterExpanded(!_footerExpanded);
      return;
    }

    if (e.key !== 'Enter' && e.code !== 'NumpadEnter') return;

    if (e.target.matches && (e.target.matches('[data-dd-qty-input]') || e.target.matches('.quantity__input'))) {
      if (!isCartPageScope(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (keyTarget.closest('[data-dd-discount-input]') && keyTarget.closest('#main-cart-footer')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var applyBtn = keyTarget.closest('[data-dd-discount]');
      if (applyBtn) {
        var btn = applyBtn.querySelector('[data-dd-discount-apply]');
        if (btn) btn.click();
      }
      return;
    }

    if (keyTarget.closest('[data-dd-note-input]') && keyTarget.closest('#main-cart-footer')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleNoteSave();
      return;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'cart') return;
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') {
      handleCheckoutSubmit(e, sub);
      return;
    }
    e.preventDefault();
  }, true);

  /* ── Handlers ── */
  function handleQtyBtn(btn, delta) {
    var container = btn.closest('[data-dd-qty-controls]');
    if (!container) return;
    var input = container.querySelector('[data-dd-qty-input]');
    if (!input) return;
    var lineKey = input.dataset.lineKey || btn.dataset.lineKey;
    var lineNumber = parseInt(input.dataset.line || btn.dataset.line || '0', 10) || 0;
    var current = parseInt(input.value, 10) || 0;
    var newQty = Math.max(0, current + delta);
    input.value = newQty;
    updateItemQuantity(lineKey, lineNumber, newQty, null, current, input);
  }

  function handleRemove(btn) {
    var lineKey = btn.dataset.lineKey;
    var lineNumber = parseInt(btn.dataset.line || '0', 10) || 0;
    var item = btn.closest('[data-dd-cart-item]');
    var qtyInput = item ? item.querySelector('[data-dd-qty-input]') : null;
    var previousQty = qtyInput ? parseInt(qtyInput.value, 10) : null;
    if (isNaN(previousQty) || previousQty == null) previousQty = 1;
    var nameEl = item ? (item.querySelector('.dd-cart-page-item__name') || item.querySelector('.dd-cart-item__name')) : null;
    var itemTitle = nameEl ? nameEl.textContent || '' : '';
    updateItemQuantity(lineKey, lineNumber, 0, itemTitle || 'Item', previousQty, qtyInput || btn);
  }

  function handleAccordionToggle(btn) {
    var accordion = btn.closest('.dd-accordion');
    if (!accordion) return;
    var nextOpen = !accordion.classList.contains('is--open');
    accordion.classList.toggle('is--open', nextOpen);
    syncCartPageAccordionAria(accordion, nextOpen);
  }

  /** Open one footer accordion (closes siblings) — e.g. discount code chip → edit field. */
  function openCartPageAccordion(target) {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var wrap = footer.querySelector('.dd-accordions');
    if (!wrap) return;
    var wanted =
      target === 'discount'
        ? footer.querySelector('[data-dd-discount-accordion]')
        : target === 'note'
          ? footer.querySelector('[data-dd-note-accordion]')
          : null;
    if (!wanted) return;
    var allAccordions = wrap.querySelectorAll('.dd-accordion');
    for (var i = 0; i < allAccordions.length; i++) {
      allAccordions[i].classList.remove('is--open');
      syncCartPageAccordionAria(allAccordions[i], false);
    }
    wanted.classList.add('is--open');
    syncCartPageAccordionAria(wanted, true);
  }

  function handleNoteSave() {
    if (_isSavingNote) return;
    var input = getScopedNode('[data-dd-note-input]');
    if (!input) return;
    var note = input.value;
    var saved = (input.dataset.ddInitialNote || '').trim();
    if ((note || '').trim() === saved) {
      announceCartStatus('Note already saved');
      if (window.ddToast) window.ddToast('Note is already saved', { type: 'info' });
      return;
    }
    _isSavingNote = true;
    startSavingNoteTimeout();
    helpers.mutateCartUpdate(
      { note: note },
      { includeSections: false, action: 'note-save', coalesceKey: helpers.makeCoalesceKey('note-save') }
    )
      .then(function () {
        var msg = note.trim() === '' ? 'Note cleared' : 'Note saved';
        input.dataset.ddInitialNote = note.trim();
        var preview = getScopedNode('[data-dd-note-preview]');
        if (preview) preview.textContent = note.trim() ? ('"' + note.trim().substring(0, 28) + '"') : '';
        updateCartPageNoteBadge(note);
        announceCartStatus(msg);
        if (window.ddToast) window.ddToast(msg, { type: 'info' });
        if (typeof helpers.scheduleCloseCartAccordions === 'function') {
          helpers.scheduleCloseCartAccordions(input);
        }
      })
      .catch(function () {
        if (window.ddToast) window.ddToast('Couldn\u2019t save note \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isSavingNote = false;
        clearSavingNoteTimeout();
      });
  }

  /* ── Order-note chip (parity with dd-mini-cart.js:459-489) ──
     Mirrors the drawer's note badge that lives in the discount strip.
     `updateCartPageNoteBadge('text')` adds/replaces the badge and the
     `updateCartPageNoteBadge('')` (or `clearCartPageNote`) removes it.
     Same DOM hooks (`[data-dd-cart-discounts]`, `[data-dd-note-badge]`,
     `[data-dd-note-badge-remove]`) so the global toast/click delegation
     works without surface-aware branching.
  */
  function updateCartPageNoteBadge(note) {
    var discountsEl = getScopedNode('[data-dd-cart-discounts]');
    if (!discountsEl) return;
    var existing = discountsEl.querySelector('[data-dd-note-badge]');
    var text = (note || '').trim();
    if (!text) {
      if (existing) existing.remove();
      return;
    }
    var clipped = text.length > 28 ? text.slice(0, 28).trimEnd() + '\u2026' : text;
    if (existing) {
      var span = existing.querySelector('span');
      if (span) span.textContent = clipped;
      return;
    }
    var safe = clipped.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var badge = document.createElement('div');
    badge.className = 'dd-cart-discount dd-cart-note-badge';
    badge.setAttribute('data-dd-note-badge', '');
    badge.innerHTML =
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
        '<polyline points="14 2 14 8 20 8"/>' +
      '</svg>' +
      '<span>' + safe + '</span>' +
      '<button type="button" class="dd-cart-discount__remove" data-dd-note-badge-remove aria-label="Clear order note">' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none">' +
          '<path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>';
    discountsEl.appendChild(badge);
  }

  function clearCartPageNote() {
    if (_isSavingNote) return;
    _isSavingNote = true;
    startSavingNoteTimeout();
    var input = getScopedNode('[data-dd-note-input]');
    helpers
      .mutateCartUpdate(
        { note: '' },
        { includeSections: false, action: 'note-save', coalesceKey: helpers.makeCoalesceKey('note-save') }
      )
      .then(function () {
        updateCartPageNoteBadge('');
        var preview = getScopedNode('[data-dd-note-preview]');
        if (preview) preview.textContent = '';
        if (input) {
          input.value = '';
          input.dataset.ddInitialNote = '';
        }
        announceCartStatus('Note cleared');
        if (window.ddToast) window.ddToast('Note cleared', { type: 'info' });
      })
      .catch(function (err) {
        console.error('[dd-cart-page] note clear error', err);
        if (window.ddToast) window.ddToast('Couldn\u2019t clear note \u2014 please try again', { type: 'error' });
      })
      .finally(function () {
        _isSavingNote = false;
        clearSavingNoteTimeout();
      });
  }

  function setFooterExpanded(expanded) {
    _footerExpanded = !!expanded;
    var summary = document.querySelector('#main-cart-footer .dd-summary');
    if (!summary) return;
    summary.classList.toggle('is--collapsed', !_footerExpanded);
    var toggle = summary.querySelector('[data-dd-footer-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', _footerExpanded ? 'true' : 'false');
  }

  function handleUpsellAdd(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var prior = btn.textContent;
    btn.textContent = 'Adding...';

    helpers.cartMutate('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, {
      sections: getCartPageAddSections(),
      action: 'cart-page-upsell-add'
    }).then(function (data) {
      btn.textContent = 'Added!';
      if (data) {
        updateEmptyState(data);
        updateThresholdBar(data);
      }
      announceCartStatus('Item added to cart');
      /* Surface a success toast (parity with mini-cart at
         dd-mini-cart.js:421-423). Live-region announce alone is
         a11y-only and isn't visible to sighted users on the page. */
      if (window.ddToast) window.ddToast('Item added to cart', { type: 'success' });
      setTimeout(function () { btn.disabled = false; btn.textContent = prior || 'Add'; }, 1500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = prior || 'Add';
      var parsed = helpers.parseCartStockError
        ? helpers.parseCartStockError(err, { operation: 'add', requestedQty: 1 })
        : null;
      var stockMsg = parsed && helpers.stockErrorMessage
        ? helpers.stockErrorMessage(parsed, { operation: 'add' })
        : null;
      var msg = (stockMsg && stockMsg.message) || 'Couldn\u2019t add item \u2014 please try again';
      var type = (stockMsg && stockMsg.toastType) || 'error';
      if (window.ddToast) window.ddToast(msg, { type: type });
    });
  }

  function handleCrossSellAdd(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var prior = btn.textContent;
    btn.textContent = 'Adding...';

    helpers.cartMutate('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, {
      sections: getCartPageAddSections(),
      action: 'cart-page-cross-sell-add'
    }).then(function () {
      btn.textContent = 'Added!';
      announceCartStatus('Item added to cart');
      /* Visible success feedback on cross-sell add (parity with mini-cart
         upsell — the drawer fires the same success toast at L421-423). */
      if (window.ddToast) window.ddToast('Item added to cart', { type: 'success' });
      setTimeout(function () { btn.disabled = false; btn.textContent = prior || 'Add'; }, 1500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = prior || 'Add';
      var parsed = helpers.parseCartStockError
        ? helpers.parseCartStockError(err, { operation: 'add', requestedQty: 1 })
        : null;
      var stockMsg = parsed && helpers.stockErrorMessage
        ? helpers.stockErrorMessage(parsed, { operation: 'add' })
        : null;
      var msg = (stockMsg && stockMsg.message) || 'Couldn\u2019t add item \u2014 please try again';
      var type = (stockMsg && stockMsg.toastType) || 'error';
      announceCartStatus('Could not add item');
      if (window.ddToast) window.ddToast(msg, { type: type });
    });
  }

  /* ── Checkout submit guard ladder ──
     Mirrors the mini-cart drawer (assets/dd-mini-cart.js L1953-2044) so
     the cart page enforces the same pre-checkout policy as the drawer.
     The order matters — earlier checks have stronger reasons to halt:

       1. Re-entrancy guard (1s nav cooldown) — prevents double-submits.
       2. Shipping-protection consent — if the merchant requires it and
          the hidden checkbox isn't checked, we can't legally proceed.
       3. Unclaimed BOGOS Color Ring — the gift is the kind of thing
          shoppers regret missing; one toast + scroll + shake.
       4. Unsaved discount/note — soft warning with a 6s cooldown so
          the shopper can submit again after fixing (or ignoring) it.
       5. Protection-off countdown — the existing 5s "you've opted out"
          interstitial before navigation.

     Steps 2-4 short-circuit submission and emit a toast; step 5 navigates
     after the countdown completes.
  */
  function handleCheckoutSubmit(e, btn) {
    var now = Date.now();
    if (now - _checkoutNavTs < 1000) { e.preventDefault(); return; }

    var consent = getScopedNode('[data-shipping-protection-consent]');
    if (consent && !consent.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      clearCheckoutWarnState();
      try {
        consent.focus({ preventScroll: true });
      } catch (ex) {
        consent.focus();
      }
      /* Drawer-canonical copy + tone (info, not warn) — see
         dd-mini-cart.js:1971-1973. The two surfaces had drifted with
         different strings and tones; standardizing on the drawer's
         longer, gentler phrasing per the parity audit. */
      if (window.ddToast) {
        window.ddToast('Please agree to the shipping protection disclaimer before checkout.', {
          type: 'info'
        });
      }
      return;
    }

    /* BOGOS unclaimed gift guard — parity with dd-mini-cart.js L1977-2007.
       `window.DDCartState` is the canonical gift-state store published by
       dd-cart-gift.js; we use the same flags the drawer reads so the two
       surfaces enforce identical eligibility logic. */
    if (window.DDCartState) {
      var giftState = window.DDCartState.get();
      if (
        giftState &&
        giftState.thresholdMet &&
        giftState.qualifies &&
        !giftState.hasColorRingInCart &&
        !giftState.declined &&
        !giftState.pendingClaim &&
        !giftState.busy &&
        hasVisibleGiftCard()
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.ddToast) {
          window.ddToast('You have an unclaimed free gift \u2014 claim or decline it before checkout.', {
            type: 'warn'
          });
        }
        /* Scroll the gift card into view + shake it after a beat so the
           shopper's eye catches the movement (matches drawer at
           dd-mini-cart.js:1995-2006). */
        var giftCard = document.querySelector('.dd-bogos-card');
        if (giftCard) {
          try {
            giftCard.scrollIntoView({ block: 'center', behavior: 'smooth' });
          } catch (ex) {
            giftCard.scrollIntoView();
          }
        }
        setTimeout(function () {
          shakeEl(giftCard);
        }, 600);
        return;
      }
    }

    /* ── Unsaved discount / unsaved note guard ──
       Parity with dd-mini-cart.js:2011-2038 (post-fix).

       Design intent: if the shopper has typed a discount code they
       haven't applied or edited a note they haven't saved, NEVER
       silently submit to /checkout — the savings or message would
       be lost without explanation. The `_checkoutWarned` flag is
       a no-spam guard for the toast (so a frantic double-click
       doesn't fire the same warn twice), NOT a "user has confirmed"
       acknowledgment. The 6s `CHECKOUT_WARN_TTL` auto-clears the
       flag so a re-warn is possible after a delay; the click
       delegation also clears it the moment the shopper hits
       Apply / Save (success path).

       Earlier this branch fell through to the rest of the ladder on
       the second click, allowing /checkout to proceed without the
       discount — see problem-log entry for details. */
    var unsavedDiscount = hasUnsavedDiscount();
    var unsavedNote = hasUnsavedNote();
    if (unsavedDiscount || unsavedNote) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!_checkoutWarned) {
        _checkoutWarned = true;
        var checkoutBtn = btn || (e.target ? e.target.querySelector('[data-dd-checkout]') : null);
        shakeEl(checkoutBtn);
        highlightUnsavedFields(unsavedDiscount, unsavedNote);
        if (window.ddToast) {
          var msg;
          if (unsavedDiscount && unsavedNote) {
            msg = 'You have an unapplied discount code and an unsaved order note.';
          } else if (unsavedDiscount) {
            msg = 'You have a discount code that hasn\u2019t been applied.';
          } else {
            msg = 'You have an order note that hasn\u2019t been saved.';
          }
          window.ddToast(msg, { type: 'warn' });
        }
        clearTimeout(_checkoutWarnResetTimer);
        _checkoutWarnResetTimer = setTimeout(clearCheckoutWarnState, CHECKOUT_WARN_TTL);
      }
      return;
    }

    /* Fields are clean — clear any stale warn flag from a prior
       warning session the shopper has since resolved without using
       Apply / Save (e.g. they manually cleared the discount input
       so the unsaved check above no longer trips). Without this, a
       lingering true `_checkoutWarned` would have nothing to gate
       on but also nothing to clear it until the 6s TTL fires. */
    if (_checkoutWarned) clearCheckoutWarnState();

    /* Protection is on by default and the off-state shows a persistent inline
       notice in the widget, so there is no checkout interstitial — let the form
       submit to /checkout natively. */
    _checkoutNavTs = now;
  }

  /* ── Checkout UI state reset on tab return / bfcache restore ──
     Clears the unsaved-discount/note warn flag so a shopper who bounces back
     from /checkout via the back button isn't blocked on their next click.
     Mirrors dd-mini-cart.js. */
  function resetCheckoutUiState() {
    clearCheckoutWarnState();
  }

  /* ── Recommendations ──
     The `[data-dd-cart-recs]` host this once-fed has no Liquid emitter
     in the current theme — the cart-page upsell rail is now
     `dd-cart-upsell.liquid` rendered via `main-cart-footer.liquid` and
     handled by `handleUpsellAdd` above. The recommendations loader
     and its 70+ lines of fetch/paint scaffolding are kept out of the
     bundle entirely. If a related-products rail is reintroduced,
     re-add the Liquid host first and revive this loader from git
     history rather than letting the dead code rot in main.
  */

  /* ── PubSub integration ── */
  var _hasPubSub = typeof subscribe === 'function' && window.Shopify && window.Shopify.PUB_SUB_EVENTS;
  if (_hasPubSub) {
    var PUB_SUB = window.Shopify.PUB_SUB_EVENTS;
    subscribe(PUB_SUB.cartUpdate, function (event) {
      var data = extractCartFromEventPayload(event);
      if (data) {
        updateEmptyState(data);
        updateThresholdBar(data);
      }
    });
  }

  /* Legacy DOM shim — only active when PubSub is unavailable */
  document.addEventListener('cart:updated', function (e) {
    if (_hasPubSub) return;
    var detail = e && e.detail ? e.detail : null;
    var data = extractCartFromEventPayload(detail);
    if (data) {
      updateEmptyState(data);
      updateThresholdBar(data);
    }
  });

  /* Reset protection-toast / checkout-warn state on tab visibility
     events (parity with dd-mini-cart.js:2082-2088). Without these,
     a shopper who bounces back from /checkout via the back button
     can land on a stuck "is--visible" protection toast or a stale
     `_checkoutWarned=true` flag that blocks their next click. */
  window.addEventListener('pageshow', resetCheckoutUiState);
  window.addEventListener('focus', resetCheckoutUiState);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetCheckoutUiState();
  });

  /* ── Regios VIP discount name resolution (cart page) ──
     Mirrors the resolver in dd-mini-cart.js so the cart page
     discount badge shows the actual tier name (e.g. "Inner Circle")
     instead of generic "Automatic account discount".              ── */
  (function resolveRegiosCartPageDiscount() {
    var custId = document.documentElement.getAttribute('data-glass-customer-id') || '0';
    var storageKey = 'dd_regios_name_' + custId;
    var resolvedName = null;

    function stamp() {
      if (!resolvedName) return;
      var labels = document.querySelectorAll('[data-dd-auto-discount-label]');
      for (var i = 0; i < labels.length; i++) {
        var txt = labels[i].textContent || '';
        var m = txt.match(/\((-[^)]+)\)/);
        var amt = m ? ' (' + m[1] + ')' : '';
        labels[i].textContent = resolvedName + amt;
      }
    }

    function resolve(name) {
      if (!name || resolvedName) return;
      resolvedName = name;
      try { sessionStorage.setItem(storageKey, name); } catch (e) {}
      stamp();
    }

    try {
      var cached = sessionStorage.getItem(storageKey);
      if (cached) { resolve(cached); return; }
    } catch (e) {}

    function tryFromCart(cart) {
      /* Mirror the drawer resolver: the Regios VIP tier is LINE-level
         (type 'script'), so it lives in cart.discount_applications, never
         in cart_level_discount_applications. Accept any non-code type
         (automatic / script / manual) with a meaningful title. */
      if (!cart) return null;
      var lists = [cart.discount_applications, cart.cart_level_discount_applications];
      for (var l = 0; l < lists.length; l++) {
        var apps = lists[l];
        if (!apps || !apps.length) continue;
        for (var i = 0; i < apps.length; i++) {
          var d = apps[i];
          if (d && d.type !== 'discount_code' && d.title && d.title !== 'Automatic') return d.title;
        }
      }
      return null;
    }

    function onApi(api) {
      if (resolvedName) return;
      var cartData = helpers.getLatestCart && helpers.getLatestCart();
      var fromCart = tryFromCart(cartData);
      if (fromCart) { resolve(fromCart); return; }
      if (!api || !api.calculateDiscountedPrices) return;
      if (!cartData || !cartData.items || !cartData.items.length) return;
      var item = cartData.items[0];
      api.calculateDiscountedPrices(
        { productId: item.product_id, variantId: item.variant_id, price: item.original_price / 100.0 },
        function (result) {
          if (result && result.discount && result.discount.name) resolve(result.discount.name);
        }
      );
    }

    if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
      onApi(window.RegiosDOPP.api.v0);
    }
    window.addEventListener('regios-dopp:api-initialized', function (e) {
      var api = e.detail && e.detail.api;
      if (api) onApi(api);
    });

    if (typeof subscribe === 'function' && window.Shopify && window.Shopify.PUB_SUB_EVENTS) {
      subscribe(window.Shopify.PUB_SUB_EVENTS.cartUpdate, function () { stamp(); });
    }
    /* Legacy DOM shim — only active when PubSub is unavailable */
    document.addEventListener('cart:updated', function () {
      if (typeof subscribe === 'function' && window.Shopify && window.Shopify.PUB_SUB_EVENTS) return;
      stamp();
    });
  })();

  initCartPageDiscountChipOverflow();
  if (typeof subscribe === 'function' && window.Shopify && window.Shopify.PUB_SUB_EVENTS) {
    subscribe(window.Shopify.PUB_SUB_EVENTS.cartUpdate, syncCartPageDiscountChipOverflow);
  }
  document.addEventListener('cart:updated', syncCartPageDiscountChipOverflow);
  document.addEventListener('dd-cart:items-swapped', syncCartPageDiscountChipOverflow);
})();
